import { ReadinessRing } from "../../../components/vitals/ReadinessRing";
import { VitalGauge } from "../../../components/vitals/VitalGauge";
import { cn } from "../../../lib/cn";

export function DemoVitalsPanel({ className }: { className?: string }) {
  return (
    <div className={cn("flex gap-4 p-3 overflow-x-auto", className)}>
      <div className="shrink-0 flex items-center">
        <ReadinessRing score={62} />
      </div>

      <div className="grid grid-cols-3 gap-2 shrink-0">
        <VitalGauge
          label="Words"
          value={2847}
          max={4500}
          showGauge={false}
          format={(n) => Math.round(n).toLocaleString()}
        />
        <VitalGauge
          label="Readability"
          value={62}
          max={100}
          format={(n) => `${Math.round(n)}`}
        />
        <VitalGauge
          label="Passive"
          value={12}
          max={100}
          format={(n) => `${Math.round(n)}%`}
          thresholds={[
            { value: 0.15, color: "var(--color-signal-green)" },
            { value: 0.30, color: "var(--color-ember-orange)" },
            { value: 1.0, color: "var(--color-soft-red)" },
          ]}
        />
        <VitalGauge
          label="Citations"
          value={8}
          max={20}
          showGauge={false}
          format={(n) => `${Math.round(n)}`}
        />
        <VitalGauge
          label="Sections"
          value={5}
          max={10}
          showGauge={false}
          format={(n) => `${Math.round(n)}`}
        />
        <VitalGauge
          label="Avg Sent"
          value={18}
          max={40}
          format={(n) => `${n.toFixed(0)} w`}
        />
      </div>
    </div>
  );
}
